import React, { ReactElement } from "react";

import "./About.scss";

export default function About(): ReactElement {
  return (
    <div className="about">
      <div className="about-content">
        <h2>Furtech Furniture, Inc.</h2>
        <p>
          is the go-to place for exceptional restaurant and retail furniture.
          Established in 2013, Furtech has become a popular destination for
          designers. Furtech offers an extensive range of products with a wide
          variety of design and cohice of materials and finishes. Furtech
          provides a complete indoor and ouotdoor furnishing soluution; chairs,
          table tops, table bases, outdoor and resort furniture nad decorative
          lights. Our extensive merchandise, high stocking levels and strong
          commitment to our customers have made Furtech the leading F&B
          contaract furniture provider in the country. Our products can be found
          in numerous local and international restaurant brands. Furtech is an
          affiliate of Magento Office Furniture, Inc., Magento Concept, inc. and
          Craft Surface Inc
        </p>
        <h2>Furtech Vision</h2>
        <p>
          We aim to be the absolute resource for restaurant contract furniture
          by having wide product selection, by bringing new trends to the
          market, by keeping sufficient stocks at all times, by providing good
          quality products and reliable service to our valued customers.
        </p>
      </div>
    </div>
  );
}
